import React, { useState, useEffect, useRef } from "react";
import "../assets/css/team.scss";
import LeftSideEditProfile from "./../LeftSideEditProfile";
import { Title } from "./../videoPhoto/Component";
import { getUserInfo } from "../../../../../../services/authService";
import {Link, useHistory} from "react-router-dom";
import {
  allTeamsListsaveStart,
  allTeamsListStart,
} from "../../../../../../redux/athlete/dashboard/editUserProfile/allTeams";
import LogoImg01 from "./../assets/img/connect-with-coaches-icon.png";
import coacheImg01 from "./../assets/img/event_default.png";
import VerificationIcon from "./../assets/img/complete-verification-icon.svg";
import closeRedIcon from "./../assets/img/close-red-icon.svg";
import SharePost from "../../homepage/posts/SharePost";
import Dialog from "@mui/material/Dialog";
import {connect, useDispatch, useSelector} from "react-redux";
import { userAcademicSchoolSave } from "../../../../../../redux/athlete/dashboard/editUserProfile/academicSchool";
import {checkPhoneNumberValidation, formatPhoneNumber, IsValidEmail, isValidPhoneNumbers} from "../../../../../../utils/validationUtils";
import {
  saveTeamQuery,
  saveSchoolQuery,
  getSchoolAndTeamTypesQuery,
  getSchoolTeamUserMappingForTeams,
  getSchoolTeamUserMappingForCoaches,
  saveSchoolTeamMapping,
} from "./TeamQuery";
import { schoolAndTeamListStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/schoolAndTeamType";
import messagePopup from "../../../../../../utils/messagePopup";
import toastr from "toastr";
import { schoolTeamUserMappingStart } from "../../../../../../redux/athlete/dashboard/editUserProfile/schoolTeamUserMapping";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../../../services/httpService";
import { saveAllReferenceDataQuery } from "../ReferencesQuery";
import { DeleteOutlineOutlined } from "@mui/icons-material";
import BackdropLoader from "../../../../../common/Loader";
import moment from 'moment'
import PhoneNumber from "../../../../../common/PhoneNumber";
import {countryListStart} from "../../../../../../redux/common/countriesList";
import {getAllCountriesQuery} from "../../../../../common/CommonQuery";
import {getCamelCase} from "../../../../../common/camelCaseFunc";
const SubHeader = ({ onSideMenuClick }) => {
  return (
    <div className="subHeader">
      <div className="menu">
        <button onClick={onSideMenuClick}>
          <span></span> Edit Profile
        </button>
      </div>
      {JSON.parse(localStorage.getItem('user')).verifiedUserStatus === 1 ? 
      <div className="profile-verified-text">
                   <span className="verifiedIcon">
                   <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26.418"
                          height="26.403"
                          viewBox="0 0 26.418 26.403"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                            transform="translate(4244.209 6690.181)"
                          />
                        </svg>
                        </span>
        Congrats your profile is verified
      </div>  
      :<div className="profile-verified-text">
        <img
          className="icon"
          src={VerificationIcon}
          alt="Verified"
        />
        Your profile is not verified for college coaches.
        <a style={{"cursor":"pointer"}} onClick={()=>window.open('https://calendly.com/sportsforce/recruiting-assessment-round-robin','_blank')}>Complete Verification Now</a>
      </div>}
      <div className="save">
        {/* <button>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13.889"
            height="13.945"
            viewBox="0 0 13.889 13.945"
          >
            <g id="save" transform="translate(0 -0.001)">
              <path
                id="Path_2125"
                data-name="Path 2125"
                d="M13.38,2.1,11.793.508A1.736,1.736,0,0,0,10.565,0H9.548V3.038a.434.434,0,0,1-.434.434H2.17a.434.434,0,0,1-.434-.434V0H.868A.868.868,0,0,0,0,.868V13.021a.868.868,0,0,0,.868.868H13.021a.868.868,0,0,0,.868-.868v-9.7A1.736,1.736,0,0,0,13.38,2.1ZM12.153,12.153H1.736V6.944H12.153Z"
                transform="translate(0 0.058)"
                fill="#3e3e3e"
              />
              <rect
                id="Rectangle_416"
                data-name="Rectangle 416"
                width="2"
                height="3"
                transform="translate(5.457 0.001)"
                fill="#3e3e3e"
              />
            </g>
          </svg>
          Save
        </button> */}
      </div>
    </div>
  );
};

const SchoolList = (props) => {
  return (
    <>
      {/*{props.schoolListData*/}
      {/*  ? props.schoolListData.map((item, idx) => {*/}
      {/*      if (item.highschoolname) {*/}
      {/*        return (*/}
                <div className="item"
                     // key={idx}
                >
                  <div className="icon-box">
                    <img src={LogoImg01} alt="logo choach" />
                  </div>
                  <div className="content-box">
                    <h4>
                      {props.schoolListData?.[0]?.highschoolname}
                      {/*{item.highschoolname}*/}
                    </h4>
                    <p>
                      {props.schoolListData?.[0]?.athleteschooltypeidmaprel === undefined
                        ? ""
                        : props.schoolListData?.[0]?.athleteschooltypeidmaprel.Schoolteamtypes[0]
                            .name}{" "}
                      {props.schoolListData?.[0]?.city ? ' in ' + props.schoolListData?.[0]?.city : ''}{props.schoolListData?.[0]?.state ? ', ' + props.schoolListData?.[0]?.state : ''}
                      {/*{item.athleteschooltypeidmaprel === undefined*/}
                      {/*  ? ""*/}
                      {/*  : item.athleteschooltypeidmaprel.Schoolteamtypes[0]*/}
                      {/*      .name}{" "}*/}
                      {/*{item.city ? ' in ' + item.city : ''}{item.state ? ', ' + item.state : ''}*/}
                    </p>
                  </div>
                </div>
        {/*      );*/}
        {/*    } else {*/}
        {/*      return "";*/}
        {/*    }*/}
        {/*  })*/}
        {/*: ""}*/}
    </>
  );
};

const TeamList = (props) => {
  return (
    <>
      {/*{props.teamsData*/}
      {/*  ? props.teamsData.map((item, idx) => {*/}
      {/*      if (item.teamname) {*/}
      {/*        return (*/}
                <div className="item"
                     // key={item.id}
                >
                  <div className="icon-box">
                    <img src={LogoImg01} alt="logo choach" />
                  </div>
                  <div className="content-box">
                    <h4>
                      {props.teamsData?.[0]?.teamname}
                      {/*{item.teamname}*/}
                    </h4>
                    <p>
                      {props.teamsData?.[0]?.teamteamtypeidmaprel === undefined
                          ? ""
                          : props.teamsData?.[0]?.teamteamtypeidmaprel?.Schoolteamtypes[0]
                              ?.name}{" "}
                      {props.teamsData?.[0]?.city ? ' in ' + props.teamsData?.[0]?.city : ''}{props.teamsData?.[0]?.state ? ', ' + props.teamsData?.[0]?.state : ''}
                     {/* {item.teamteamtypeidmaprel === undefined*/}
                     {/*   ? ""*/}
                     {/*   : item.teamteamtypeidmaprel?.Schoolteamtypes[0]*/}
                     {/*       ?.name}{" "}*/}
                     {/*{item.city ? ' in ' + item.city : ''}{item.state ? ', ' + item.state : ''}*/}
                    </p>
                  </div>
                </div>
        {/*      );*/}
        {/*    } else {*/}
        {/*      return "";*/}
        {/*    }*/}
        {/*  })*/}
        {/*: ""}*/}
    </>
  );
};

const EditSection = (props) => {
  const [toggle, setToggle] = React.useState(true),
        [showModal, setShowModal] = useState(false);
  let history = useHistory();
  const [coachFields, setCoachFields] = useState({
    coachName: "",
    coachEmail: "",
    Id: "",
    type: "",
    name: "",
  });

  const [notification, setNotification] = useState(false);
 //for progress bar
  const dispatch = useDispatch()
  useEffect(() => {
    if (props.teamAndCoachList && props.teamAndCoachList[0]) {
      if (props.isSchool) {
        let fieldsT = coachFields;
        fieldsT["Id"] = props.teamAndCoachList[0]
          ? props.teamAndCoachList[0].id
          : "";
        fieldsT["name"] = props.teamAndCoachList[0]
          ? props.teamAndCoachList[0].highschoolname
          : "";
        fieldsT["type"] =
          props.teamAndCoachList[0] &&
          props.teamAndCoachList[0].athleteschooltypeidmaprel &&
          props.teamAndCoachList[0].athleteschooltypeidmaprel.Schoolteamtypes[0]
            ? props.teamAndCoachList[0].athleteschooltypeidmaprel
                .Schoolteamtypes[0].type
            : "";
        setCoachFields({ ...fieldsT });
      } else {
        let fieldsT = coachFields;
        fieldsT["Id"] = props.teamAndCoachList[0]
          ? props.teamAndCoachList[0].id
          : "";
        fieldsT["name"] = props.teamAndCoachList[0]
          ? props.teamAndCoachList[0].teamname
          : "";
        fieldsT["type"] =
          props.teamAndCoachList[0] &&
          props.teamAndCoachList[0].teamteamtypeidmaprel &&
          props.teamAndCoachList[0].teamteamtypeidmaprel.Schoolteamtypes[0]
            ? props.teamAndCoachList[0].teamteamtypeidmaprel.Schoolteamtypes[0]
                .type
            : "";

        setCoachFields({ ...fieldsT });
      }
    }
  }, [props.teamAndCoachList]);
  const [errors, setErrors] = useState({});
  const [coachId, setCoachId] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showEditPanel, setShowEditPanel] = React.useState(null);
  const [teamCoaches, setTeamCoaches] = useState([]);
  const [modalData, setModalData] = useState([]);
  const onToggleClick = () => {
    setToggle(!toggle);
  };
  const handleModal = () => {
    const { formIsValid } = handleValidation();
    if(formIsValid){
      setModalData(coachFields)
      setShowModal(!showModal);
    }
  };

  const handleChange = (field, e) => {
    // e?.preventDefault();
    setErrors({
      errorsT: "",
    });
    let fieldsT = coachFields;
    if(field == "coachNumber"){
      if(e?.target.value?.length < 11){
        // fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
        fieldsT[field] = formatPhoneNumber(e.target.value)
        setCoachFields({ ...fieldsT });
      }
    }else{
      fieldsT[field] = e ? (e.target ? e.target.value : e) : e;
      setCoachFields({ ...fieldsT });
    }
  };
 useEffect(()=> {
   if(props.teamAndCoachList &&
    props.teamAndCoachList[0] &&
    props.teamAndCoachList[0].coach ){
    setTeamCoaches(props.teamAndCoachList[0].coach)
    }
 }, [props.teamAndCoachList])



 const handleValidation = (fieldname, e) => {
    let errorsT = errors;
    let formIsValid = true;
    let fieldValue = e ? (e.target ? e.target.value : e) : e;
    let updatedValue = fieldValue;

    if(!!coachFields["coachNumber"]){
      if(!checkPhoneNumberValidation(coachFields?.coachNumber, coachFields.countryDetails.countryShortName)){
        errorsT["coachNumber"] = "Invalid phone number";
        formIsValid = false
      }
    }

    //sName validations
    if (fieldname === undefined || fieldname === "coachName") {
      if (fieldname === undefined) {
        fieldValue = coachFields["coachName"] ? coachFields["coachName"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["coachName"];
      if (!updatedValue) {
        formIsValid = false;
            errorsT["coachName"] = "Please enter a valid coach's name.";
        // errorsT["coachName"] = "Please enter your coach's name";
      } else {
        let names = coachFields["coachName"].trim().split(" ");
        if (names.length < 2) {
          formIsValid = false;
          errorsT["coachName"] =
            "Please enter your coach's fullname seprated by space";
        }else if(names.length >= 2){
          //this is for alphabets only
          let regex = /^[a-zA-Z]*$/,
              status =[];
            names.map(reg => regex.test(reg) == false && status.push(reg))
          if(status?.length > 0){
            formIsValid = false;
            errorsT["coachName"] = "Please enter a valid coach's name.";
            // errorsT["coachName"] =
            //     "Coach Name Should Only Be Alphabets";
          }
        }
      }
    }

    //coach email validations
    if (fieldname === undefined || fieldname === "coachEmail") {
      if (fieldname === undefined) {
        fieldValue = coachFields["coachEmail"] ? coachFields["coachEmail"] : "";
        updatedValue = fieldValue;
      }
      delete errorsT["coachEmail"];
      if (!updatedValue) {
        formIsValid = false;
        errorsT["coachEmail"] = "Email Address is required";
      } else if (!IsValidEmail(updatedValue)) {
        formIsValid = false;
        errorsT["coachEmail"] = "Please enter valid email id";
      }
    }

    setErrors({
      ...errorsT,
    });
    return {
      formIsValid,
      updatedValue,
    };
  };

  //Save School Function
  const saveSchoolData = (e) => {
    if (coachFields.coachName != "" || coachFields.coachEmail != "") {
      props.saveData.userAcademicSchoolSave({
        query: saveSchoolQuery,
        variables: {
          obj: {
            id: parseInt(coachFields.Id),
            userid: getUserInfo() ? getUserInfo().id : 0,
            highschoolname: coachFields.name,
            verifiedbycoachname: coachFields.coachName,
            verifiedbycoachemail: coachFields.coachEmail,
          },
        },
      });
    }
  };
  useEffect(()=>{
    const filedT = {...coachFields }
    filedT['countryDetails'] = getMyCountryDetails(1)
    setCoachFields(filedT)
  },[props?.allCountryList])

  const getMyCountryDetails = (id) => {
    let countryT = null;
    props?.allCountryList.map((country) => {
      if (country.id === id) {
        countryT = {
          value: country.id,
          label: country.countryName + `(+${country.countryCode})`,
          flag: country.countryFlagImage,
          countryCode: country.countryCode,
          countryShortName: country.countryShortName,
        };
      }
    });
    return countryT;
  };


  //Save Team function
  const saveTeamData = () => {
    if (coachFields.coachName != "" || coachFields.coachEmail != "") {
      props.saveData.allTeamsListsaveStart({
        query: saveTeamQuery,
        variables: {
          obj: {
            id: parseInt(coachFields.Id),
            userid: getUserInfo() ? getUserInfo().id : 0,
            teamname: coachFields.name,
            verifiedbycoachname: coachFields.coachName,
            verifiedbycoachemail: coachFields.coachEmail,
          },
        },
      });
    }
  };

  //Send request
  const sendRequest = async (e) => {
    e.preventDefault();
    let duplicatecoach = true;
   const isDuplicateCoach = teamCoaches && teamCoaches.map((coach, index)=> {
      if((coach.coachemail?.toLowerCase() == coachFields.coachEmail?.toLowerCase())
      ){
      }
    })
     if(coachFields.coachEmail?.toLowerCase() == getUserInfo()?.Email?.toLowerCase()){
      duplicatecoach = false;
      messagePopup("", "The Coach Email ID Cannot Be Same As Athlete Email ID", "error")
    }
    const { formIsValid } = handleValidation();
    if(duplicatecoach){
    if (formIsValid) {
      let res;
      let data;
      if (!props.teamAndCoachList[0]?.coachid) {
        let coachnames = coachFields.coachName.trim().split(" ");
        data = {
          coachFirstName: getCamelCase(coachnames[0]),//coachnames[0]
          coachLastName: !!coachnames[coachnames?.length - 1] ? getCamelCase(coachnames[coachnames?.length - 1]) : "",//coachnames[1] ? coachnames[1] : ""
          coachEmailId: coachFields.coachEmail,
          createdby: getUserInfo().id,
          teamId: props.isSchool ? 0 : coachFields.Id,
          schoolId: props.isSchool ? coachFields.Id : 0,
          userId: getUserInfo().id,
          mappingId: props.teamAndCoachList[0]?.userMappingid,
        };
      } else {
        let coachnames = coachFields.coachName.trim().split(" ");
        let variables = {
          obj: {
            teamId: props.isSchool ? null : coachFields.Id,
            schoolId: props.isSchool ? coachFields.Id : null,
            userId: getUserInfo().id,
            active: 1,
          },
        };
        res = await fetchGraphMethod(saveSchoolTeamMapping, variables, true);
        let mappingId = 0;
        if (
          res &&
          res.data &&
          res.data.data.saveSchoolteamusermapping &&
          res.data.data.saveSchoolteamusermapping.id
        ) {
          mappingId = res.data.data.saveSchoolteamusermapping.id;
        }
        // return;
        data = {
          coachFirstName: getCamelCase(coachnames[0]),//coachnames[0]
          coachLastName: !!coachnames[coachnames?.length - 1] ? getCamelCase(coachnames[coachnames?.length - 1]) : "",//coachnames[1] ? coachnames[1] : ""
          coachEmailId: coachFields.coachEmail,
          createdby: getUserInfo().id,
          teamId: props.isSchool ? 0 : coachFields.Id,
          schoolId: props.isSchool ? coachFields.Id : 0,
          userId: getUserInfo().id,
          mappingId: mappingId,
          primaryteamstatus: props.teamAndCoachList[0].isPrimary ? 1 : 0,
          secondaryteamstatus: props.teamAndCoachList[0].isSecondary ? 1 : 0,
        };
      }
      let referenceData = {
        obj: {
          userId: getUserInfo().id,
          refemailid: coachFields.coachEmail,
          reffirstname: getCamelCase(data.coachFirstName),//data.coachFirstName
          reflastname: getCamelCase(data.coachLastName),//data.coachLastName
          refphone : coachFields?.coachNumber ?? "",
          refcountryid: coachFields?.countryDetails.value ?? 1,
          team: coachFields.name,
        },
      };
      res = await fetchGraphMethod(
        saveAllReferenceDataQuery,
        referenceData,
        true
      );
      res = await fetchMethod(
        `/api/Athleteschools/addCoachData`,
        data,
        "post",
        true
      );
      if (res && res.status == 200 && res?.data?.response?.status == 200) {
        setNotification(true);
        if(props && props?.saveData?.location?.state?.schoolTeamMapping?.previousPage === "checklist"){
          dispatch({type:"RENDER_COUNT_START", payload: 1})
          setTimeout(()=>{
           // window.location.href='/#/checklist'
            history?.push('/checklist')
          },300)
        }else{
          dispatch({type:"RENDER_COUNT_START", payload: 1})
          setTimeout(()=>{
            history.push("/teams");
          },300)
        }
      } else {
        messagePopup("", !!res?.data?.response?.msg ?
            res?.data?.response?.msg : "SomeThing Went wrong" , "warning");
      }
    }
  }
  };

  //edit Request
  const onDeleteHandler = async (e, coach) => {
    e.preventDefault();
    if(props.teamAndCoachList[0].coach.length > 1){
    let variables = {
      obj: {
        id: coach.mappingId,
        userId: getUserInfo().id,
        active: 1,
        coatchid: null,
      },
    };
    let res = await fetchGraphMethod(saveSchoolTeamMapping, variables, true);

    if (res && res.status == 200) {
      // messagePopup("", "Coach Deleted Successfully", "success");
      toastr.success("Coach Deleted Successfully", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
      history.push("/teams");
    } else {
      // messagePopup("", "Something Went Wrong Please try again", "warning");
      toastr.warning("Something Went Wrong Please try again", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    }
  }
  else{
    // messagePopup("", "You must invite another coach before you can delete this one", "warning");
    toastr.warning("You must invite another coach before you can delete this one", "", {
      progressBar : true,timeOut: 2000,
      closeButton: true, positionClass: "toast-top-full-width",
      showEasing: "swing", fadeIn: 40000,
      preventDuplicates: true,
    })
  }
  };
  const isCoachPresent = () => {
    if (
      props.teamAndCoachList &&
      props.teamAndCoachList[0] &&
      props.teamAndCoachList[0].coach &&
      props.teamAndCoachList[0].coach[0]
    ) {
      return Object.entries(props.teamAndCoachList[0].coach[0]).length > 0;
    }
    return false;
  };
  const  timeDiffCalc = (signedCommitmentDate, currentDate) => {
    const activeDate = new Date(signedCommitmentDate)
    let diffInMilliSeconds =
        Math.abs(currentDate - activeDate) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;
    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    const months = Math.floor(days % 365 / 30);

    const years = Math.floor(days / 365)
    return { days, hours, minutes, months, years };
  }
  const onResend = async (e, coach, props) => {
    e.preventDefault();
    let data = {
      coachEmailId: coach?.coachemail ?? "",
      // athleteName: getUserInfo().FirstName + " " + getUserInfo().lastName,
      coachFirstName: coach?.coachfirstname ?? "",
       coachLastName: coach?.coachlastname ?? "",
      schoolId: props?.saveData?.location?.state?.schoolTeamMapping?.schoolid ?? 0,
      teamId: props?.saveData?.location?.state?.schoolTeamMapping?.teamid ?? 0,
      userId: getUserInfo()?.id
    };
    let res = await fetchMethod(
        //earlier below api is used as duw to mail text and subject it has  been replace
      // "/api/Athleteschools/editCoachData",
        '/api/Athleteschools/resendEmail',
      data,
      "post",
      true
    );
    if (res && res.status == 200) {
      // messagePopup("", "Email Sent Successfully", "success");
      toastr.success("Email Sent Successfully", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    } else {
      // messagePopup("", "Something Went Wrong Please try again", "warning");
      toastr.warning("Something Went Wrong Please try again", "", {
        progressBar : true,timeOut: 2000,
        closeButton: true, positionClass: "toast-top-full-width",
        showEasing: "swing", fadeIn: 40000,
        preventDuplicates: true,
      })
    }
  };
  const getAllCoach = () => {
    if (
      props.teamAndCoachList &&
      props.teamAndCoachList[0] &&
      props.teamAndCoachList[0].coach &&
      props.teamAndCoachList[0].coach[0] &&
      Object.entries(props.teamAndCoachList[0].coach[0]).length > 0
    ) {
      return props.teamAndCoachList[0].coach.map((coach) => {
        return (
          <li className="team-flex-item" key={coach.id}>
            <div className="item-content-box">
              <div className="icon-box">
                <img src={coacheImg01} alt="coache" />
              </div>
              <div className="content-box">
                <h4>
                  {coach.coachfirstname} {coach.coachlastname}
                </h4>
                <p>
                  {/*{coach.typename} {coachFields.name}*/}
                </p>
                <div className="gray-text">
                {/*Last active 2 days ago*/}
                {/*  Last active {moment(new Date()).diff(moment(coach?.createdon),'days') + 1} days ago*/}
                  {timeAgo(coach?.createdon)}
                </div>
              </div>
            </div>
            <div className="item resend-request-button">
              <button className="btn green" onClick={(e) => onResend(e, coach, props)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13.344"
                  height="13.344"
                  viewBox="0 0 13.344 13.344"
                >
                  <path
                    id="send"
                    d="M13.134.082a.465.465,0,0,1,.2.477L11.428,12a.468.468,0,0,1-.238.335.456.456,0,0,1-.231.06.5.5,0,0,1-.179-.037L7.408,10.976l-1.8,2.2a.439.439,0,0,1-.365.171.4.4,0,0,1-.164-.03.476.476,0,0,1-.313-.447v-2.6L11.2,2.383,3.238,9.27.3,8.064a.471.471,0,0,1-.06-.849L12.627.067A.455.455,0,0,1,12.865,0a.462.462,0,0,1,.268.082Z"
                    transform="translate(0.002)"
                    fill="#fff"
                  ></path>
                </svg>
                Resend
              </button>
              {/*earlier check ins on coach.createdBy*/}
              {coach.createdByAdmin == getUserInfo().id ? (
                <button
                  className="btn"
                  onClick={(e) => {
                    onDeleteHandler(e, coach);
                  }}
                >
                  <DeleteOutlineOutlined />
                  Delete
                </button>
              ) : (
                ""
              )}
            </div>
          </li>
        );
      });
    }
    return "";
  };
  const timeAgo = (value) =>{
    const currentDate = new Date();
    if (value != null) {
      let abc = timeDiffCalc(value, currentDate);
        const signedSignature =
          abc.years > 1
              ? abc.years + " years ago"
              : abc.years == 1
              ? abc.years + " year  ago"
              : abc.months > 1
                  ? abc.months + " months  ago"
                  : abc.months == 1
                      ? abc.months + " month  ago"
                      : abc.days == 1
                          ? abc.days + " day  ago"
                          : abc.days > 0
                              ? abc.days + " days  ago"
                              : abc.hours > 0
                                  ? abc.hours + " hours  ago"
                                  : abc.minutes > 0
                                      ? abc.minutes + " mins  ago"
                                      : abc.minutes == 1
                                          ? abc.minutes + " min  ago"
                                          : "just now";
        return signedSignature

    } else {
      return (
          "Just Now"
          // <>
          //   <div className="note"></div>
          // </>
      );
    }
  }
  const handleCountryChange = (option) => {
    const fieldsT = { ...coachFields };
    fieldsT["countryDetails"] = option;
    setCoachFields({ ...fieldsT, coachNumber: "" });
  };
  return (
    <div className="editSection">
      <Title title={"Teams"} />
      <div className="check-list-sec">
        <div className="editprofile-common-form team-common-form">
          <h3>Connect With Coaches</h3>
          <div className="coches-request-wrap">
            <div className="connect-with-coaches-top-box">
              {props.isSchool ? (
                <SchoolList schoolListData={props.teamAndCoachList} />
              ) : (
                <TeamList teamsData={props.teamAndCoachList} />
              )}
              <div
                className="request-massage-box"
                style={{ display: notification ? "block" : "none" }}
              >
                <p>Invite has been sent.</p>
                <button
                  className="close-button"
                  onClick={(e) => setNotification(false)}
                >
                  <img src={closeRedIcon} alt="close button" />
                </button>
              </div>
            </div>

            <div className="coaching-staff-content-box">
              <h4>Coaching Staff:</h4>
              {/*if there is no coaches in listing then below msg appear*/}
              {!isCoachPresent() ? (
                <p>
                  No coaches on Sportsforce yet. Invite your coaches to join.
                </p>
              ) : (
                ""
              )}
              <ul className="coache-listing">{getAllCoach()}</ul>
            </div>
          </div>
          <form className="invite-coach-wrap">
            <div
                // id="invite-coach-toggle"
                className="notification-setting-box">
              <div
                className={`notification-title after-remove`}
              >
                Invite another coach
                <span
                    onClick={onToggleClick}
                    className={`notification-btn-toggle ${toggle && "active"}`}>
                </span>
              </div>
              <div className={`notification-content ${toggle && "active"}`}>
                <div className="fieldBox flexBox">
                  <div className="half">
                    <label>
                      Coach Name <sup>*</sup>
                    </label>
                    <input
                      type="text"
                      placeholder="First & Last Name"
                      value={coachFields.coachName}
                      onChange={(e) => handleChange("coachName", e)}
                    />
                    <div className="error">{errors["coachName"]}</div>
                  </div>
                  <div className="half">
                    <label>
                      Coach Email <sup>*</sup>
                    </label>
                    <input
                      type="email"
                      placeholder="Email here"
                      value={coachFields.coachEmail}
                      onChange={(e) => handleChange("coachEmail", e)}
                    />
                    <div className="error">{errors["coachEmail"]}</div>
                  </div>
                </div>
                <div className="fieldBox flexBox">
                  <div className="half">
                    <label>
                      Coach Phone Number
                    </label>
                    <div style={{background:"#fff"}}>
                    <PhoneNumber
                        dropdownName="countryCode"
                        dropdownOnChange={handleCountryChange}
                        dropdownValue={coachFields?.countryDetails || 1}
                        dropDownOptions={
                          props?.allCountryList &&
                          props?.allCountryList.map((item) => ({
                            value: item.id,
                            label: item.countryName + `(+${item.countryCode})`,
                            flag: item.countryFlagImage,
                            countryCode: item.countryCode,
                            countryShortName: item.countryShortName,
                          }))
                        }
                        formatOptionLabel={(option, { context, selectValue }) => {
                          return context === "menu" ? (
                              <>
                                <img
                                    src={option.flag}
                                    alt=""
                                    style={{ width: "40px", marginRight: "15px" }}
                                />
                                <span>{option.label}</span>
                              </>
                          ) : (
                              <>
                                <img
                                    src={option.flag}
                                    alt=""
                                    style={{ width: "40px", marginRight: "15px" }}
                                />
                                <span>+{option.countryCode}</span>
                              </>
                          );
                        }}
                        inputPlaceholder="Phone Number"
                        inputType="phonenumber"
                        inputValue={coachFields?.coachNumber || ""}
                        inputOnChange={(e) => {
                          handleChange("coachNumber", {
                            target: {
                              value: e.target.value.replace(/[^0-9]/gi, ""),
                            },
                          });
                        }}
                    />
                    </div>
                    {/*<input*/}
                    {/*    type="number"*/}
                    {/*    placeholder="Phone Number here"*/}
                    {/*    value={coachFields.coachNumber}*/}
                    {/*    onChange={(e) => handleChange("coachNumber", e)}*/}
                    {/*/>*/}
                    <div className="error">{errors["coachNumber"]}</div>
                  </div>
                </div>
                {/*Jira Task 294*/}
                {/*<p>*/}
                {/*  <a onClick={handleModal}>Other Ways to Invite</a>*/}
                {/*</p>*/}
              </div>
            </div>
            <div className="button-box">
              <Link className="btn orange" to="/teams">
                Back
              </Link>
              <button className="btn green" onClick={(e) => sendRequest(e)}>
                Send Request
              </button>
            </div>
          </form>
        </div>
      </div>
      <Dialog open={showModal}
              onClose={(event, reason)=> {
                if (reason == "backdropClick" || reason == "escapeKeyDown") {
                  handleModal()
                }
              }}
              className="matDialogCustom"
      >
        <SharePost
            handleModal={handleModal}
            modalData={modalData}
            pageType={'AddCoach'}
            userID={getUserInfo()?.id || 0}
        />
      </Dialog>
    </div>
  );
};

const AddCoaches = (props) => {
  const store = useSelector(store => store)
  const [sideMenuOpen, setSideMenu] = useState(store?.athlete?.editUserProfileData?.teamSideBarStatus?.status || false);
  const [teamArray, setTeamArray] = useState([]);
  const [teamAndCoachList, setTeamAndCoachList] = useState([]);
  const [allCountryList, setAllCountryList] = useState([
    {
      id: 0,
      countrycode: "",
      countryname: "",
      countryflagimage: "",
    },
  ]);
  const fakeInput = useRef(null);
  const dispatch = useDispatch()
  let history = useHistory();
  const onSideMenuClick = () => {
    setSideMenu(!sideMenuOpen);
    dispatch({type:"TEAM_SIDE_BAR_START" ,payload:{status: !sideMenuOpen}})
  };
  useEffect(() => {
    props.schoolAndTeamListStart({
      query: getSchoolAndTeamTypesQuery,
      variables: null,
    });
    props.countryListStart({
      query: getAllCountriesQuery,
    });
    getUserMapping();
    fakeInput.current.focus();
    fakeInput.current.select();
  }, []);
  useEffect(() => {
    if (
      props.schoolTeamUserMapping.data &&
      props.schoolTeamUserMapping.data.schoolTeamUserMapping &&
      props.schoolTeamUserMapping.data.schoolTeamUserMapping
        .Schoolteamusermappings
    ) {
      let teamArrayT = [];
      props.schoolTeamUserMapping.data.schoolTeamUserMapping.Schoolteamusermappings.map(
        (school) => {
          if (
            school.schoolteamusermappingschoolidmaprel &&
            school.schoolteamusermappingschoolidmaprel.Athleteschools &&
            school.schoolteamusermappingschoolidmaprel.Athleteschools[0]
          ) {
            teamArrayT.push({
              ...school.schoolteamusermappingschoolidmaprel.Athleteschools[0],
              userMappingid: school.id,
              coachid: school.coatchid,
              isPrimary: school.primaryteamstatus ? true : false,
              isSecondary: school.secondaryteamstatus ? true : false,
            });
          }
          if (
            school.schoolteamusermappingteamidmaprel &&
            school.schoolteamusermappingteamidmaprel.Teams &&
            school.schoolteamusermappingteamidmaprel.Teams[0]
          ) {
            teamArrayT.push({
              ...school.schoolteamusermappingteamidmaprel.Teams[0],
              userMappingid: school.id,
              coachid: school.coatchid,
              isPrimary: school.primaryteamstatus ? true : false,
              isSecondary: school.secondaryteamstatus ? true : false,
            });
          }
        }
      );
      setTeamArray([...teamArrayT]);
    }
  }, [props.schoolTeamUserMapping.data]);
  useEffect(() => {
    getCoachDetails();
  }, [teamArray]);

  //Effect To Map All Countries List
  useEffect(() => {
    if (props.allCountries && props.allCountries.data) {
      setAllCountryList(props.allCountries.data);
    }
  }, [props.allCountries]);
  function getCoachDetails() {
    let teamAndCoachListT = [];
    Promise.all(
      teamArray.map((team) => {
        if (
          team.id != props.location.state.schoolTeamMapping.teamid &&
          team.id != props.location.state.schoolTeamMapping.schoolid
        ) {
          return;
        }

        let variables = { obj: {} };
        if (team.teamname) {
          variables.obj = { teamid: team.id };
        }
        if (team.highschoolname) {
          variables.obj = { schoolid: team.id };
        }
        fetchGraphMethod(
          getSchoolTeamUserMappingForCoaches,
          variables,
          true
        ).then((res) => {
          let coachInfo;
          coachInfo = res.data.data;
          let TeamAndCoachDetail = { ...team, coach: [] };
          if (
            coachInfo &&
            coachInfo.allSchoolteamusermappings &&
            coachInfo.allSchoolteamusermappings.Schoolteamusermappings &&
            coachInfo.allSchoolteamusermappings.Schoolteamusermappings[0]
          ) {
            coachInfo.allSchoolteamusermappings.Schoolteamusermappings.map(
              (coach) => {
                let coachDetail = {};
                if (
                  coach.schoolteamusermappingcoatchidmaprel &&
                  coach.schoolteamusermappingcoatchidmaprel
                    .Coachandteamdetails &&
                  coach.schoolteamusermappingcoatchidmaprel
                    .Coachandteamdetails[0]
                ) {
                  //this key as admin as discuss with backend outer created is added on allSchoolteamusermappings
                  coachDetail['createdByAdmin'] = coach?.createdby;
                  coachDetail.mappingId = coach.id;
                  coachDetail.id =
                    coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].id;
                  coachDetail.coachfirstname =
                    coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachfirstname;
                  coachDetail.coachlastname =
                    coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachlastname;
                  coachDetail.coachemail =
                    coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachemail;
                  coachDetail.createdby =
                    coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].createdby;
                  coachDetail.createdon =
                      coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].createdon;
                  if (
                    coach.schoolteamusermappingcoatchidmaprel
                      .Coachandteamdetails[0]
                      .coachandteamdetailscoachtypeidmaprel &&
                    coach.schoolteamusermappingcoatchidmaprel
                      .Coachandteamdetails[0]
                      .coachandteamdetailscoachtypeidmaprel.Coachtypes[0]
                  ) {
                    coachDetail.typename =
                      coach.schoolteamusermappingcoatchidmaprel.Coachandteamdetails[0].coachandteamdetailscoachtypeidmaprel.Coachtypes[0].coachtypename;
                  }
                }
                if (Object.entries(coachDetail).length > 0) {
                  TeamAndCoachDetail.coach.push(coachDetail);
                }
              }
            );
            teamAndCoachListT.push(TeamAndCoachDetail);
          }
          setTeamAndCoachList([...teamAndCoachListT]);
        });
      })
    );
  }
    
  const getUserMapping = () => {
    if (props.location.state != undefined) {
      let variables = {
        obj: {
          id: props.location.state.schoolTeamMapping.userMappingid,
          userid: getUserInfo().id,
          teamid: props.location.state.schoolTeamMapping.teamid,
          schoolid: props.location.state.schoolTeamMapping.schoolid,
        },
      };
      props.schoolTeamUserMappingStart({
        query: getSchoolTeamUserMappingForTeams,
        variables,
      });
    } else {
      history.push("/teams/add-team");
    }
  };
  //this is used for scrolling the page on top
  useEffect(()=>{
    setTimeout(()=>{
     window.scrollTo(0,0)
    },1800)
  },[])
  return (
    <div className="pageContent">
      <div className="editProfile">
        <div className="container">
          <div
            id="wrapper"
            className={`flex ${sideMenuOpen ? "inactive" : ""}`}
          >
            <BackdropLoader open={props.schoolTeamUserMapping.loading} />
            <input className="fakeInput" type="text" ref={fakeInput} />
            <SubHeader onSideMenuClick={onSideMenuClick} />
            <div className="sidebar">
              <LeftSideEditProfile />
            </div>
            <EditSection
              saveData={props}
              allCountryList={allCountryList}
              isSchool={
                props.location.state != undefined
                  ? props.location.state.schoolTeamMapping.isSchool
                  : null
              }
              teamAndCoachList={teamAndCoachList}
              schoolAndTeamType={
                props.schoolAndTeamList.data &&
                props.schoolAndTeamList.data.schoolAndTeams
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allCountries: state.common.countries,
    allTeamList: state.athlete.editUserProfileData.teamsList,
    allSchoolList: state.athlete.editUserProfileData.userAcademicSchool,
    schoolAndTeamList: state.athlete.editUserProfileData.schoolAndTeamTypes,
    schoolTeamUserMapping:
      state.athlete.editUserProfileData.schoolTeamUserMapping,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    countryListStart: (data) => dispatch(countryListStart(data)),
    allTeamsListStart: (data) => dispatch(allTeamsListStart(data)),
    allTeamsListsaveStart: (data) => dispatch(allTeamsListsaveStart(data)),
    userAcademicSchoolSave: (data) => dispatch(userAcademicSchoolSave(data)),
    schoolAndTeamListStart: (data) => dispatch(schoolAndTeamListStart(data)),
    schoolTeamUserMappingStart: (data) =>
      dispatch(schoolTeamUserMappingStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCoaches);
